// extracted by mini-css-extract-plugin
export default {"link":"Toolbar_link__4kGHJ"};